const FALLBACK = "-";

function text(value) {
  return String(value || "").trim();
}

function lower(value) {
  return text(value).toLowerCase();
}

function upper(value) {
  return text(value).toUpperCase();
}

function humanize(value) {
  const raw = text(value);
  if (!raw) return FALLBACK;
  const normalized = raw.replace(/[_-]+/g, " ").toLowerCase();
  return normalized.charAt(0).toUpperCase() + normalized.slice(1);
}

export function formatEnvironmentLabel(value) {
  return {
    sandbox: "Sandbox",
    homologacao: "Homologação",
    producao: "Produção",
    misto: "Misto",
    sem_banco: "Sem banco",
  }[lower(value)] || humanize(value);
}

export function formatOriginLabel(value) {
  return {
    erp: "MasterVendas",
    avulso: "Hub (avulso)",
    hub: "UP2 Finance Hub",
    manual: "Manual",
  }[lower(value)] || humanize(value);
}

export function formatBoletoTypeLabel(value) {
  return {
    boleto: "Boleto",
    boleto_hibrido: "Boleto híbrido (PIX)",
    pix: "PIX",
    pix_cobranca: "PIX cobrança",
  }[lower(value)] || humanize(value);
}

export function formatBoletoStatusLabel(value) {
  return {
    EMITIDO: "Emitido",
    REGISTRADO: "Registrado",
    PAGO: "Pago",
    VENCIDO: "Vencido",
    CANCELADO: "Cancelado",
    BAIXADO: "Baixado",
    PROTESTADO: "Protestado",
  }[upper(value)] || humanize(value);
}

export function formatBankStatusLabel(value) {
  return {
    EMITIDO: "Emitido",
    REGISTRADO: "Registrado",
    PAGO: "Pago",
    VENCIDO: "Vencido",
    CANCELADO: "Cancelado",
    BAIXADO: "Baixado",
    PROTESTADO: "Protestado",
    NAO_CONFIRMADO: "Não confirmado",
    NAO_CONSULTADO: "Não consultado",
    CONSULTA_NAO_IMPLEMENTADA: "Consulta não implementada",
    ERRO_CONSULTA: "Erro na consulta",
    MOCK: "Simulação",
  }[upper(value)] || humanize(value);
}

export function formatWebhookEventLabel(value) {
  return {
    boleto_emitido: "Boleto emitido",
    boleto_registrado: "Boleto registrado",
    boleto_pago: "Boleto pago",
    boleto_baixado: "Boleto baixado",
    boleto_cancelado: "Boleto cancelado",
    boleto_vencido: "Boleto vencido",
    boleto_protestado: "Boleto protestado",
    pix_recebido: "PIX recebido",
    lembrete_vencimento: "Lembrete antes do vencimento",
    vencimento_hoje: "Vencimento hoje",
    vencido: "Boleto vencido",
    comprovante_pago: "Comprovante de pagamento",
  }[lower(value)] || humanize(value);
}

export function formatDeliveryStatusLabel(value) {
  return {
    delivered: "Entregue",
    failed: "Falhou",
    pending: "Pendente",
    sent: "Enviado",
  }[lower(value)] || humanize(value);
}
